class ReelsConfig {

    private _data: any;

    constructor() {
        this._data = {};
    }

    init(data) {
        this._data = data || {}; //this._data => initResult.data.behavior
    }

    setSymbolHeight(height) {
        this._data['symbolHeight'] = height;
    }

    getSymbolHeight() {
        return this._data['symbolHeight'];
    }

    setSymbolOffsetY(y) {
        this._data['symbolOffsetY'] = y;
    }

    getSymbolOffsetY() {
        return this._data['symbolOffsetY'];
    }

    /** REEL SPIN CONFIG */

    getStartDelay() {
        this._data['reel']['startDelay'];
    }

    getStopDelay() {
        return this._data['reel']['stopDelay'];
    }

    getSpinCommonSpeed() {
        return this._data['reel']['spin']['commonSpeed'];
    }

    getDelayBtwReelStarts() {
        return this._data['reel']['spin']['delayBetweenReelStarts'];
    }

    getDelayBtwReelStops() {
        return this._data['reel']['spin']['delayBetweenReelStops'];
    }

    getSpinDuration() {
        // try{
        return this._data['reel']['spin']['duration'];
        // } catch(e) {
        //     return 0;
        // }
    }

    getEnabledForceStop() {
        return this._data['reel']['spin']['enableForceStop'];
    }

    getFreeSpinSpeed() {
        return this._data['reel']['spin']['freeSpinSpeed'];
    }

    getScatterDelay() {
        return this._data['reel']['spin']['scatterDelay'];
    }

    getScatterDuration() {
        return this._data['reel']['spin']['scatterDuration'];
    }

    getScatterSpeed() {
        return this._data['reel']['spin']['scatterSpeed'];
    }

    /** GET REEL ACCELERATION CONFIG */

    getAccHeight() {
        try{
            return this._data['reel']['acceleration']['accelerationHeight'];
        } catch (e) {
            return 0;
        }
    }

    getAccKeepTime() {
        return this._data['reel']['acceleration']['keepTime'];
    }

    getAccMoveTime() {
        return this._data['reel']['acceleration']['moveTime'];
    }

    getAccMoveBackTime() {
        return this._data['reel']['acceleration']['moveBackTime'];
    }

    getAccSpinRatio() {
        return this._data['reel']['acceleration']['spinAccelerationRatio'];
    }

    getAccSwingCount() {
        return this._data['reel']['acceleration']['swingCount'];
    }

    /** GET REEL BRAKE CONFIG */

    getBrakeHeight() {
        return this._data['reel']['brake']['brakeHeight'];
    }

    getBrakeMoveBackTime() {
        return this._data['reel']['brake']['moveBackTime'];
    }

    getBrakeMoveTime() {
        return this._data['reel']['brake']['moveTime'];
    }

    getBrakeKeepTime() {
        return this._data['reel']['brake']['keepTime'];
    }

    getBrakeSwingCount() {
        return this._data['reel']['brake']['swingCount'];
    }

}

export default ReelsConfig;